const prefix = 'FLIGHT_VARIABLES';
export const createActionTypes = (resource) => ({
    LOAD: `${prefix}/${resource}/LOAD'`,
    LOADING: `${prefix}/${resource}/LOADING'`,
    LOADED: `${prefix}/${resource}/LOADED'`,
});
export const loadFlightVariablesActionTypes = createActionTypes('LOAD_TREATMENT_VARIABLES');
// Action Creators
export const loadFlightVariables = (flightId, workspaceId, managementGroup) => {
    return {
        type: loadFlightVariablesActionTypes.LOAD,
        payload: {
            flightId: flightId,
            workspaceId: workspaceId,
            managementGroup: managementGroup,
        },
    };
};
export const loadingFlightVariables = (payload) => {
    return {
        type: loadFlightVariablesActionTypes.LOADING,
        payload: payload,
    };
};
export const loadedFlightVariables = (payload, result) => {
    return {
        type: loadFlightVariablesActionTypes.LOADED,
        payload: {
            flightId: payload.flightId,
            result: result,
        },
    };
};

//# sourceMappingURL=FlightVariables.ducks.js.map
